/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-drawer-continue-shopping]');

    if (!button) {
      return;
    }

    var closeButton = document.querySelector('#cart-drawer [data-cart-drawer-toggle]');

    if (closeButton) {
      closeButton.click();
    }
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
